import { STRINGS } from 'config';
import React, { useEffect, useState } from 'react';
import { getCustomLandingPageMessage } from 'store/action/landingPageMessage';
import { useAppState } from 'store/configureStore';
import { SettingsSection } from 'components/Setting/style';
import { CustomLandingPageMessageForm } from 'components/CustomLandingPageMessage/messageForm';
import { ShowCustomLandingPageMessageToggle } from 'components/CustomLandingPageMessage/messageToggle';

const { IDLE, PENDING, SUCCEEDED, FAILED } = STRINGS.REQUEST_STATUS;

const MAX_MESSAGE_LENGTH = 1000;

export const CustomLandingPageMessage = () => {
  const {
    app: {
      selectedPractice,
      selectedPracticeHasAdminRights,
    },
  } = useAppState();

  const [message, setMessage] = useState('');
  const [showMessage, setShowMessage] = useState(false);
  const [saveRequestStatus, setSaveRequestStatus] = useState(IDLE);
  const [getRequestStatus, setGetRequestStatus] = useState(IDLE);

  const isGetRequestPending = getRequestStatus === PENDING;
  const isSaveRequestPending = saveRequestStatus === PENDING;
  const isToggleDisabled = !selectedPracticeHasAdminRights
    || message.length > MAX_MESSAGE_LENGTH
    || !message.length;

  useEffect(() => {
    setGetRequestStatus(PENDING);
    getCustomLandingPageMessage(selectedPractice.id).then(response => {
      setGetRequestStatus(typeof response.message === 'string' ? SUCCEEDED : FAILED);
      setSaveRequestStatus(IDLE);
      setMessage(response.message || '');
      setShowMessage(response.showMessage || false);
    });
  }, [selectedPractice.id]);

  const onChangeMessage = event => {
    setMessage(event.target.value);
  };

  return (
    <SettingsSection data-automation="CustomLandingPageMessageWrapper">
      <CustomLandingPageMessageForm
        message={message}
        showMessage={showMessage}
        maxMessageLength={MAX_MESSAGE_LENGTH}
        selectedPractice={selectedPractice}
        selectedPracticeHasAdminRights={selectedPracticeHasAdminRights}
        isFormDisabled={!selectedPracticeHasAdminRights}
        onChangeMessage={onChangeMessage}
        isGetRequestPending={isGetRequestPending}
        isSaveRequestPending={isSaveRequestPending}
        setSaveRequestStatus={setSaveRequestStatus}
      />

      <ShowCustomLandingPageMessageToggle
        message={message}
        showMessage={showMessage}
        selectedPractice={selectedPractice}
        selectedPracticeHasAdminRights={selectedPracticeHasAdminRights}
        maxMessageLength={MAX_MESSAGE_LENGTH}
        isToggleDisabled={isToggleDisabled}
        setShowMessage={setShowMessage}
        isGetRequestPending={isGetRequestPending}
        isSaveRequestPending={isSaveRequestPending}
        setSaveRequestStatus={setSaveRequestStatus}
      />
    </SettingsSection>
  );
};
